import videojs from 'video.js';
import jsonp from '../../base/jsonp';
import util from '../../utilPc/';

const PCUtil = new util();
const VideoComponent = videojs.getComponent('Component');

/**
 * 控制条上方APP推广栏
 */
class AppSpreadAd extends VideoComponent {
    constructor(player, options) {
        super(player, options);

        /**
         * 设置15秒自动隐藏
         */
        this.delayHideTimer = setTimeout(() => {
            this.addClass('appspread-hide');
            clearTimeout(this.delayHideTimer);
        }, 15000);

        this.on('mouseover', () => {
            clearTimeout(this.delayHideTimer);
            this.removeClass('appspread-hide');
        });

        this.on('mouseleave', () => {
            this.delayHideTimer = setTimeout(() => {
                this.addClass('appspread-hide');
                clearTimeout(this.delayHideTimer);
            }, 15000);
        });

        // 条栏文字区域关闭按钮
        const textCloseBtn = this.getChild('AppSpreadText')
            .getChild('RecommendText')
            .getChild('CloseBtn');

        textCloseBtn.on('closeArea', this.handleClickCloseTextArea.bind(this));

        // 下载客户端按钮
        const downAppBtn = this.getChild('AppSpreadText')
            .getChild('RecommendText')
            .getChild('DownLoadApp');

        downAppBtn.on('downApp', this.handleClickDownApp.bind(this));

        // 控制APP推广条栏显示次数
        this.showAppSpread();
    }

    showAppSpread() {
        let playtimes = PCUtil.playerGetCookie('playtimes') || 1;

        PCUtil.playerSetCookie('playtimes', ++playtimes, {
            domain: '.ifeng.com',
            path: '/',
            expires: 60 * 24 * 360,
        });

        // 每播放三次显示一次，其余不显示
        if (playtimes % 3 !== 1) {
            this.addClass('appspread-hide');
            clearTimeout(this.delayHideTimer);
        }
    }

    handleClickCloseTextArea() {
        this.addClass('appspread-hide');
        this.clearTimeout(this.delayHideTimer);
    }

    handleClickDownApp() {
        this.getChild('DownQRCode').trigger('downApp');
    }

    createEl() {
        return super.createEl('div', {
            className: 'feng-control-appspread',
        });
    }

    initChildren() {
        this.addChild('AppSpreadText');
        this.addChild('DownQRCode');
    }
}

videojs.registerComponent('AppSpreadAd', AppSpreadAd);

class AppSpreadText extends VideoComponent {
    createEl() {
        return super.createEl('div', {
            className: 'feng-control-appText',
        });
    }

    initChildren() {
        this.addChild('RecommendText');
    }
}

videojs.registerComponent('AppSpreadText', AppSpreadText);

class RecommendText extends VideoComponent {
    createEl() {
        return super.createEl('div', {
            className: 'feng-control-recommendNews',
        });
    }

    initChildren() {
        this.addChild('SpreadText');
        this.addChild('CloseBtn');
        this.addChild('DownLoadApp');
    }
}

videojs.registerComponent('RecommendText', RecommendText);

/**
 * 推荐文本
 * 接口请求
 */
class SpreadText extends VideoComponent {
    constructor(player, options) {
        super(player, options);
        this.getRecommendText();
    }

    async getRecommendText() {
        try {
            const textData = await jsonp('//v.ifeng.com/flash/data/app/tuig_h5.js', {
                data: {},
                jsonpCallback: 'tugiCallback',
                cache: false,
                timeout: 10000,
            });

            if (textData && textData.text) {
                this.el().innerHTML = textData.text;
            }
        } catch (e) {
            console.error(e);
        }
    }

    createEl() {
        return super.createEl('p', {
            className: 'textCon',
        });
    }
}

videojs.registerComponent('SpreadText', SpreadText);

/**
 * 下载APP按钮
 */
class DownLoadApp extends VideoComponent {
    constructor(player, options) {
        super(player, options);

        this.on('click', this.handleClickDownLoad);
    }

    handleClickDownLoad() {
        this.trigger('downApp');
    }

    createEl() {
        return super.createEl('a', {
            className: 'downApp',
            innerHTML: '下载客户端',
        });
    }
}

videojs.registerComponent('DownLoadApp', DownLoadApp);

/**
 * 关闭条栏按钮
 */
class CloseBtn extends VideoComponent {
    constructor(player, options) {
        super(player, options);

        this.on('click', this.handleCloseSpread);
    }

    handleCloseSpread() {
        this.trigger('closeArea');
    }

    createEl() {
        return super.createEl('span', {
            className: 'close_appspread_text',
        });
    }
}

videojs.registerComponent('CloseBtn', CloseBtn);

class DownQRCode extends VideoComponent {
    constructor(player, options) {
        super(player, options);

        const qrAreaCloseBtn = this.getChild('CloseBtn');

        qrAreaCloseBtn.on('closeArea', this.handleCloseQRcode.bind(this));

        this.on('downApp', this.showQRcode.bind(this));
    }

    handleCloseQRcode() {
        this.addClass('qrcode-hide');
    }

    showQRcode() {
        this.removeClass('qrcode-hide');
    }

    createEl() {
        return super.createEl('div', {
            className: 'feng-downApp-QRcodeBox qrcode-hide',
            innerHTML: `<p>下载客户端观看</p>
                        <img class="js_phoneWatchImg" src="//y3.ifengimg.com/a/2015/0831/download.jpg" alt="" title="" width="110" height="110">`,
        });
    }

    initChildren() {
        this.addChild('CloseBtn');
    }
}

videojs.registerComponent('DownQRCode', DownQRCode);
